"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliceDetailsLayout = exports.SliceDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var main_aside_1 = require("../elements/main-aside");
var grid_1 = require("../elements/grid");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var entity_list_section_1 = require("./entity-list-section");
var entity_value_1 = require("./entity-value");
var entity_link_value_1 = require("./entity-link-value");
var lodash_1 = require("lodash");
var content_title_1 = require("../elements/content-title");
var markdown_1 = require("../elements/markdown");
var block_layout_1 = require("./block-layout");
var entity_linked_items_grid_1 = require("./entity-linked-items-grid");
exports.SliceDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(4))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", ";\n    font-size: ", ";\n    font-weight: 400;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n\n    a {\n      font-size: 1em;\n    }\n  "], ["\n    padding: ", ";\n    font-size: ", ";\n    font-weight: 400;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n\n    a {\n      font-size: 1em;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('dark'))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ClipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var VideoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitlesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: ", " 2px;\n    ", ";\n  "], ["\n    padding: ", " 2px;\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG_END()),
  tablet: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n  "], ["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0), theme_1.theme.FONT_SIZE(20))
});
var PretitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 300;\n    color: ", ";\n  "], ["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 300;\n    color: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('text'))
});
var SubtitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('text'))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding: ", ";\n\n    p {\n      margin-top: 1em;\n    }\n  "], ["\n    padding: ", ";\n\n    p {\n      margin-top: 1em;\n    }\n  "])), theme_1.theme.UNIT(3))
});
var OutroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LinkedValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkedLinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BlocksStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin: ", ";\n  "], ["\n    margin: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var BlockStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Titles: styled_components_1.default.header(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Pretitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Grid: (0, styled_components_1.default)(entity_linked_items_grid_1.EntityLinkedItemsGrid)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  LinkedValue: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), LinkedValueStyles),
  LinkedLinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), LinkedLinkValueStyles),
  Intro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Outro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Blocks: (0, styled_components_1.default)(grid_1.Grid)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), BlocksStyles),
  Block: (0, styled_components_1.default)(block_layout_1.BlockLayout)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), BlockStyles)
};
var SliceDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    banner = props.banner,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter;
  var intro = entity.intro,
    outro = entity.outro,
    title = entity.title,
    pretitle = entity.pretitle,
    subtitle = entity.subtitle,
    content = entity.content,
    color = entity.color,
    backgroundColor = entity.backgroundColor,
    _a = entity.people,
    people = _a === void 0 ? [] : _a,
    _b = entity.organisations,
    organisations = _b === void 0 ? [] : _b,
    _c = entity.blocks,
    blocks = _c === void 0 ? [] : _c,
    _d = entity.pages,
    pages = _d === void 0 ? [] : _d,
    _e = entity.feedEntries,
    feedEntries = _e === void 0 ? [] : _e,
    _f = entity.links,
    links = _f === void 0 ? [] : _f,
    _g = entity.images,
    images = _g === void 0 ? [] : _g,
    _h = entity.backgroundImages,
    backgroundImages = _h === void 0 ? [] : _h,
    parentPage = entity.parentPage,
    viewTarget = entity.viewTarget,
    subviewTarget = entity.subviewTarget;
  var video = (0, lodash_1.get)(entity, 'video');
  var hasVideo = !!video;
  var hasTitles = title || subtitle || pretitle;
  var hasAside = asideHeader || asideFooter;
  var gridItems = (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([parent && react_1.default.createElement(My.LinkValue, {
    entity: parentPage,
    label: "Parent {{PAGE}}:"
  })], __read(pages.map(function (page) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: page
    });
  })), false), __read(people.map(function (person) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: person
    });
  })), false), __read(organisations.map(function (organisation) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: organisation
    });
  })), false), __read(feedEntries.map(function (feedEntry) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: feedEntry
    });
  })), false), __read(links.map(function (link) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      entity: link
    });
  })), false), __read(images.map(function (image) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      label: "Image",
      entity: image
    });
  })), false), __read(backgroundImages.map(function (image) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      label: "Background Image",
      entity: image
    });
  })), false), [color && react_1.default.createElement(My.LinkedValue, {
    variant: 'card',
    showMenu: true,
    entity: color
  }), backgroundColor && react_1.default.createElement(My.LinkedValue, {
    variant: 'card',
    showMenu: true,
    label: "Background {{COLOR}}",
    entity: backgroundColor
  })], false));
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, hasTitles && react_1.default.createElement(My.Titles, null, pretitle && react_1.default.createElement(My.Pretitle, null, react_1.default.createElement(markdown_1.Markdown, {
      text: pretitle
    })), title && react_1.default.createElement(My.Title, null, react_1.default.createElement(markdown_1.Markdown, {
      text: title
    })), subtitle && react_1.default.createElement(My.Subtitle, null, react_1.default.createElement(markdown_1.Markdown, {
      text: subtitle
    }))), !!gridItems.length && react_1.default.createElement(My.Grid, {
      spacing: 4,
      columns: 3,
      items: gridItems
    }), intro && react_1.default.createElement(My.Intro, {
      entity: intro
    }), content && react_1.default.createElement(My.Content, {
      entity: content
    }), outro && react_1.default.createElement(My.Outro, {
      entity: outro
    }), !!blocks.length && react_1.default.createElement(My.Blocks, {
      spacing: 8,
      columns: 3,
      items: blocks.map(function (block, index) {
        return react_1.default.createElement(My.Block, {
          number: index + 1,
          key: block.id,
          entity: block
        });
      })
    }), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, asideFooter)
  }));
};
exports.SliceDetailsLayout = SliceDetailsLayout;
exports.SliceDetailsLayout.defaultProps = exports.SliceDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43;